import { render, staticRenderFns } from "./edc-form-history-version.vue?vue&type=template&id=69bb88e6&scoped=true&"
import script from "./edc-form-history-version.vue?vue&type=script&lang=js&"
export * from "./edc-form-history-version.vue?vue&type=script&lang=js&"
import style0 from "./edc-form-history-version.vue?vue&type=style&index=0&id=69bb88e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bb88e6",
  null
  
)

component.options.__file = "edc-form-history-version.vue"
export default component.exports